<template>
    <div class="faq-and-contact-section">
        <PageFrameContainer>
            <div class="faq-and-contact-form">
                <div class="faq">
                    <img class="faq-icon" src="./../../../assets/pages/main/faq.svg"/>
                    <MainPageFAQCard
                            :title="$t('pages.main.faq.faqAppliedCard.title')">
                        <ul>
                            <li v-for="(i,index) in $t('pages.main.faq.faqAppliedCard.appliedList')" :key="index">{{i}}</li>
                        </ul>
                    </MainPageFAQCard>
                    <MainPageFAQCard v-for="(i,index) in $t('pages.main.faq.faqCards')"
                                        :key="index" :title="i.title">{{i.text}}
                    </MainPageFAQCard>
                </div>
                <div class="contact-form">
                    <MainPageContactForm/>
                </div>
            </div>
        </PageFrameContainer>
    </div>

</template>

<script>
    import MainPageFAQCard from "../parts/MainPageFAQCard";
    import PageFrameContainer from "../../../components/PageFrameContainer";
    import MainPageContactForm from "../parts/MainPageContactForm";

    export default {
        name: "FaqAndContactSection",
        components: {MainPageContactForm, PageFrameContainer, MainPageFAQCard}
    }
</script>

<style scoped lang="scss">
    @import "../../../theme/theme";

    /* faq-and-contact-form */
    .faq-and-contact-section {
        padding-top: 2em;
        padding-bottom: 3em;
    }

    .faq-and-contact-form {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 2em;

        .faq {
            display: grid;

            .faq-icon {
                width: 20em;
                justify-self: center;
            }
        }
    }

    /* faq*/

    /* Contact form*/
    .contact-form {
        display: grid;
        grid-gap: 0.6em;
        align-self: start;
    }

    @media (max-width: 55em) {
        .faq-and-contact-form {
            grid-template-columns: 1fr;
        }
    }

    @media (min-width: 55em) {
        .faq-and-contact-form {
            grid-template-columns: 6fr 4fr;
        }
    }
</style>